import { message } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, ExclamationCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';


message.config({
  top: 50,
  duration: 4,
  maxCount: 5,
  rtl: false,
  prefixCls: 'ant-message',
});

const MessageComponent = {
  // Success message
  success: (content, duration = 3, options = {}) => {
    return message.success({
      content,
      duration,
      icon: <CheckCircleOutlined style={{ color: '#52c41a' }} />,
      style: {
        marginTop: '20px',
        fontSize: '14px',
        fontFamily: 'inherit',
        zIndex: 9999,
        ...options.style,
      },
      ...options,
    });
  },

  // Error message
  error: (content, duration = 4, options = {}) => {
    return message.error({
      content,
      duration,
      icon: <CloseCircleOutlined style={{ color: '#ff4d4f' }} />,
      style: {
        marginTop: '20px',
        fontSize: '14px',
        fontFamily: 'inherit',
        zIndex: 9999,
        ...options.style,
      },
      ...options,
    });
  },

  // Warning message
  warning: (content, duration = 3, options = {}) => {
    return message.warning({
      content,
      duration,
      icon: <ExclamationCircleOutlined style={{ color: '#faad14' }} />,
      style: {
        marginTop: '20px',
        fontSize: '14px',
        fontFamily: 'inherit',
        zIndex: 9999,
        ...options.style,
      },
      ...options,
    });
  },

  // Info message
  info: (content, duration = 3, options = {}) => {
    return message.info({
      content,
      duration,
      icon: <InfoCircleOutlined style={{ color: '#1890ff' }} />,
      style: {
        marginTop: '20px',
        fontSize: '14px',
        fontFamily: 'inherit',
        zIndex: 9999,
        ...options.style,
      },
      ...options,
    });
  },

  // Loading message
  loading: (content = 'Carregando...', duration = 0, options = {}) => {
    return message.loading({
      content,
      duration,
      style: {
        marginTop: '20px',
        fontSize: '14px',
        fontFamily: 'inherit',
        zIndex: 9999,
        ...options.style,
      },
      ...options,
    });
  },

  // Destroy all messages
  destroy: () => {
    message.destroy();
  },

  // Processar notifications do backend automaticamente
  processBackendNotifications: (errorResponse) => {
    const notifications = errorResponse?.response?.data?.notifications || 
                         errorResponse?.data?.notifications;
    
    if (notifications && Array.isArray(notifications) && notifications.length > 0) {
      notifications.forEach((notif, index) => {
        if (notif.message) {
          // Usar setTimeout para evitar conflitos no React 19
          setTimeout(() => {
            MessageComponent.error(notif.message, 5, {
              key: `backend-notification-${notif.identifier || index}`,
            });
          }, index * 100); // Delay pequeno entre múltiplas mensagens
        }
      });
      return true;
    }
    return false;
  },

  // Shortcuts para operações comuns
  userCreated: (userName) => {
    return MessageComponent.success(`Usuário ${userName} criado com sucesso!`);
  },

  userUpdated: (userName) => {
    return MessageComponent.success(`Usuário ${userName} atualizado com sucesso!`);
  },

  userDeleted: (userName) => {
    return MessageComponent.success(`Usuário ${userName} removido com sucesso!`);
  },

  passwordChanged: () => {
    return MessageComponent.success('Senha alterada com sucesso!');
  },

  operationFailed: (operation = 'operação') => {
    return MessageComponent.error(`Erro ao realizar ${operation}.`);
  },

  requiredFields: () => {
    return MessageComponent.warning('Preencha todos os campos obrigatórios.');
  },

  noPermission: (action = 'realizar esta ação') => {
    return MessageComponent.error(`Você não tem permissão para ${action}.`);
  },

  // Custom message with options
  custom: (type, content, options = {}) => {
    const defaultOptions = {
      duration: 3,
      style: {
        marginTop: '20px',
        zIndex: 9999,
      },
    };

    const mergedOptions = { ...defaultOptions, ...options };

    switch (type) {
      case 'success':
        return message.success({
          content,
          icon: <CheckCircleOutlined style={{ color: '#52c41a' }} />,
          ...mergedOptions,
        });
      case 'error':
        return message.error({
          content,
          icon: <CloseCircleOutlined style={{ color: '#ff4d4f' }} />,
          ...mergedOptions,
        });
      case 'warning':
        return message.warning({
          content,
          icon: <ExclamationCircleOutlined style={{ color: '#faad14' }} />,
          ...mergedOptions,
        });
      case 'info':
        return message.info({
          content,
          icon: <InfoCircleOutlined style={{ color: '#1890ff' }} />,
          ...mergedOptions,
        });
      default:
        return message.info({
          content,
          ...mergedOptions,
        });
    }
  },
};

export default MessageComponent; 